// extracted by mini-css-extract-plugin
module.exports = {"container":"Stats_container__1CDZL"};